import { Injectable } from '@angular/core';
import {
  GetRetailCustomerConfigurationRequest,
  GetRetailCustomerConfigurationResponse,
  RetailCustomerConfigurationApiService,
  UpsertRetailCustomerConfigurationRequest,
  UpsertRetailCustomerConfigurationRequestInterface,
} from '@vendasta/billing';
import { Observable } from 'rxjs';
import { map, mapTo } from 'rxjs/operators';
import {
  RetailCustomerConfiguration,
  collectionMethodToApi,
  retailCustomerConfigurationFromApi,
} from './retail-customer-configuration';

@Injectable({ providedIn: 'root' })
export class RetailCustomerConfigurationService {
  constructor(private configApiService: RetailCustomerConfigurationApiService) {}

  get(merchantId: string, customerId: string): Observable<RetailCustomerConfiguration> {
    const req = new GetRetailCustomerConfigurationRequest({
      merchantId,
      customerId,
    });
    return this.configApiService
      .get(req)
      .pipe(
        map((resp: GetRetailCustomerConfigurationResponse) => retailCustomerConfigurationFromApi(resp.configuration)),
      );
  }

  upsert(req: UpsertRetailCustomerConfigurationRequestInterface): Observable<null> {
    return this.configApiService
      .upsert(
        new UpsertRetailCustomerConfigurationRequest({
          ...req,
          collectionMethod: collectionMethodToApi(req.collectionMethod),
        }),
      )
      .pipe(mapTo(null));
  }
}
